import StaffShell from "../components/StaffShell";
import PhotoQueuePanel from "../components/PhotoQueuePanel";
import { Camera } from "lucide-react";
import { T, useI18n } from "../lib/i18n";

export default function PhotographerDash() {
  useI18n();
  return (
    <StaffShell title={T("Photographer")} subtitle={T("Live photo queue")}>
      <div className="card-elev p-4 mb-4">
        <div className="flex items-center gap-2 mb-2">
          <Camera className="w-4 h-4 text-primary-motif" />
          <div className="font-display text-lg">{T("Queue")}</div>
        </div>
        <PhotoQueuePanel />
      </div>
    </StaffShell>
  );
}
